export default [
  {
    title: 'Портфель',
    subtitle: 'Сводная информация',
    key: 'portfolio',
    class: 'blue lighten-2 white--text',
    icon: 'mdi-briefcase-variant',
    link: '/client/portfolio'
  },
  {
    title: 'Сделки',
    subtitle: 'Изменения в составе потрфеля',
    key: 'target_contrib',
    icon: 'mdi-history',
    class: 'green lighten-2 white--text',
    link: '/client/portfolio_history'
  }
]
